import { ZfStack, ZfTextButton, ZfTooltip } from '@zafire/react';
import { ZfDividerTitle } from 'components/common/ZfDividerTitle';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmCloseProductModal } from '../../ConfirmCloseProductModal';

type Props = {
  isPending: boolean;
  bodyText: string;
  addTopMargin: boolean;
  disabledReason?: string | null;
  isClosing: boolean;
  onConfirmClose: () => Promise<void>;
};

export const CloseProductSection: React.FC<Props> = ({
  isPending,
  bodyText,
  addTopMargin,
  disabledReason,
  isClosing,
  onConfirmClose,
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [isConfirming, setIsConfirming] = useState(false);
  const isCloseDisabled = isPending || Boolean(disabledReason);

  const handleOpenConfirm = () => {
    if (isCloseDisabled) return;
    setIsConfirming(true);
  };

  const handleCancel = () => {
    setIsConfirming(false);
  };

  return (
    <ZfStack direction="column">
      <ZfDividerTitle label="Close product" addTopMargin={addTopMargin} />
      <div
        ref={setAnchorEl}
        data-testid="remove-product-button-wrapper"
        style={{ display: 'inline-block', pointerEvents: 'auto' }}
      >
        <ZfTextButton
          size="small"
          hierarchy="secondary"
          id="remove-product-button"
          data-testid="remove-product-button"
          kind="destructive"
          leadingIcon="delete"
          onClick={handleOpenConfirm}
          disabled={isCloseDisabled}
        >
          Close product
        </ZfTextButton>
        {disabledReason && anchorEl && <ZfTooltip text={disabledReason} anchor={() => anchorEl} side="top" />}
      </div>
      {isConfirming && (
        <ConfirmCloseProductModal
          title={t('pb.deleteproductmodal.title', 'Close product')}
          bodyText={bodyText}
          confirmLabel={t('pb.deleteproductmodal.submit', 'Close product')}
          cancelLabel={t('pb.deleteproductmodal.cancel', 'Cancel')}
          isPending={isClosing}
          onConfirm={onConfirmClose}
          onCancel={handleCancel}
        />
      )}
    </ZfStack>
  );
};
